import { Dialog } from "primereact/dialog";
import { useAuth } from "../contexts/AuthInfoContext";
import { useGeneral } from "../contexts/GeneralInfoContext";
import { usePrivate } from "../contexts/PrivateInfoContext";

function ProviderSelector({ close }) {
  const { providers, setProvider, setProvider_id, logCredor } = useAuth();
  const { setReload } = usePrivate();
  const { setReloadLayout } = useGeneral();

  function mudaCredor(credor) {
    setProvider(credor.nome_fantasia ? credor.nome_fantasia : credor.nome);
    setProvider_id(credor.usuario_id);
    //console.log(credor.usuario_id)
    logCredor(credor.usuario_id);
    close();
    setReload((prevReload) => !prevReload);
    setReloadLayout((prevReload) => !prevReload);
  }

  return (
    <Dialog
      visible
      closable={false}
      showHeader={false}
      style={{
        width: window.innerWidth > 820 ? "60vw" : "100vw",
        minHeigth: "30vh",
        minWidth: "20vh",
        textAlign: "center",
        //borderRadius: '30px',
        //padding: '10px'
      }}
      className="boletosDialog"
    >
      <div className="font-lato mt-4">
        <h5>
          <b>Selecione a empresa a qual deseja visualizar suas contas:</b>
        </h5>
        <div className="grid grid-flow-row grid-cols-2 auto-rows-auto md:grid justify-center md:justify-center gap-[5vh] py-[5vh]">
          {providers.map((credor) => (
            // <Button
            // onClick={()=>mudaCredor(credor)}
            // className="break-normal"
            // key={credor.usuario_id} >
            //     {credor.nome}
            // </Button>
            <button
              className="bg-[#001d74] w-full h-full text-slate-50 p-2
                        hover:bg-gradient-to-b hover:from-[#0000ff] hover:to-[#0040ff] 
                        hover:shadow-[1.5px_1.5px_5px_5px_#4300fa85] transition duration-300
                        disabled:hover:from-[#001d74]/0 disabled:hover:to-[#001d74]/0 disabled:hover:shadow-none
                        text-[2.5vh] font-lato font-bold disabled:bg-[#001d74]/70 rounded-md "
              onClick={() => mudaCredor(credor)}
              type="button"
              key={credor.usuario_id}
            >
              {credor.nome_fantasia ? credor.nome_fantasia : credor.nome}
            </button>
          ))}
        </div>
      </div>
    </Dialog>
  );
}

export default ProviderSelector;
